import React from 'react';
import { createdAt } from '../../../../helpers/Dialogs';

import { useSelector } from 'react-redux';
import userDefaultAvatar from '../../../../assets/img/placeholder-user.png';
import { onUserImgError, randomAvatarColors } from '../../../../helpers/Helpers';
import { Image } from 'antd';

const IndividualChatItem = ({ chat, index, isCurrentChat, handleChatClick }) => {
    const account = useSelector((state) => state.account);

    const created_at = createdAt(chat.last_message);
    const isBlocked = chat.last_message && chat.last_message.type === 'blocked' ? true : false;

    if (chat.admin_closed || chat.closed) {
        return (
            <div
                key={chat.id}
                className={isCurrentChat ? 'chat-nav-item is-active' : 'chat-nav-item'}
                onClick={(e) => handleChatClick(chat.id)}
            >
                <div className="chat-nav-info">
                    <h3 className="chat-nav-name d-inline-block">{`${
                        chat.prospect ? chat.prospect.name : chat.name
                    }`}</h3>
                    <p className="chat-nav-text">Closed</p>
                </div>
                <div className="chat-nav-data">
                    <div className="chat-icons-group">
                        <p className={chat.new_messages > 0 ? 'chat-list-counter' : 'hidden-block'}>
                            {chat.new_messages}
                        </p>
                    </div>
                    <p className="chat-nav-date">{created_at}</p>
                </div>
            </div>
        );
    }

    return (
        <div
            key={chat.id}
            className={isCurrentChat ? 'chat-nav-item is-active' : 'chat-nav-item'}
            onClick={(e) => handleChatClick(chat.id)}
        >
            <div className="chat-nav-avatar">
                {account.account_info.key === 'prospect' && chat.first_ambassador ? (
                    <div className="chat-random-img-block">
                        <Image
                            className="chat-name-img"
                            src={
                                chat.first_ambassador.avatar
                                    ? chat.first_ambassador.avatar.sizes['70x70'] ||
                                      chat.first_ambassador.avatar.original
                                    : userDefaultAvatar
                            }
                            onError={onUserImgError}
                            alt={
                                chat.first_ambassador.name ? chat.first_ambassador.name.slice(0, 1).toUpperCase() : 'D'
                            }
                        />
                    </div>
                ) : (
                    account.account_info.key === 'univercity-student' &&
                    chat.prospect && (
                        <div className="chat-random-img-block">
                            {chat.prospect.avatar ? (
                                <Image
                                    className="chat-name-img"
                                    src={chat.prospect.avatar.sizes['70x70'] || chat.prospect.avatar.original}
                                    onError={onUserImgError}
                                    alt={chat.prospect.name ? chat.prospect.name.slice(0, 1).toUpperCase() : 'D'}
                                />
                            ) : (
                                <div
                                    className="chat-name-img"
                                    style={{
                                        backgroundColor:
                                            randomAvatarColors.length - 1 > index
                                                ? randomAvatarColors[index]
                                                : randomAvatarColors[
                                                      Math.floor(Math.random() * randomAvatarColors.length)
                                                  ],
                                    }}
                                >
                                    <span>
                                        {chat.prospect.name ? chat.prospect.name.slice(0, 1).toUpperCase() : 'D'}
                                    </span>
                                </div>
                            )}
                        </div>
                    )
                )}
                {!chat.prospect && !chat.first_ambassador && (
                    <div className="chat-random-img-block">
                        <div
                            className="chat-name-img"
                            style={{
                                backgroundColor:
                                    randomAvatarColors.length - 1 > index
                                        ? randomAvatarColors[index]
                                        : randomAvatarColors[Math.floor(Math.random() * randomAvatarColors.length)],
                            }}
                        >
                            <span>D</span>
                        </div>
                    </div>
                )}
            </div>
            <div className="chat-nav-item-info">
                {account.account_info.key === 'prospect' && chat.first_ambassador ? (
                    <h3 className="chat-nav-name">{`${chat.first_ambassador.name} ${
                        chat.first_ambassador.last_name ? chat.first_ambassador.last_name : ''
                    }`}</h3>
                ) : (
                    <div className="chat-name-blocked-container">
                        <h3 className="chat-name-name">
                            {chat.prospect && chat.prospect.name ? chat.prospect.name : 'Deleted User'}
                        </h3>
                        {isBlocked ? <span className="blocked-text sidebar">-blocked</span> : null}
                    </div>
                )}
                <p className="chat-nav-date">{created_at}</p>
            </div>
            <div className="chat-nav-data">
                <div className="chat-icons-group">
                    {chat.new_messages > 0 && <span className="chat-list-counter">{chat.new_messages}</span>}
                </div>
            </div>
        </div>
    );
};

export default IndividualChatItem;
